import axios from "axios";
import { toast } from "react-toastify";
import { LOGIN_USER } from "../../types/UserType";

const addUserAction = (data) => {
	return {
		type: LOGIN_USER,
		payload: data,
	};
};

export const changePassword = (newPassword) => {
	return async (dispatch) => {
		try {
			const token = localStorage.getItem("access-token");
			
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
					Authorization: `Bearer ${token}`,
				},
				url: `user/change-password`,
				data: {
					newPassword: newPassword,
				},
			});
			
			// Update stored token and user data
			dispatch(addUserAction(data.user));
			localStorage.setItem("access-token", data.token);
			localStorage.setItem("role", data.user.role);
			localStorage.setItem("user", data.user.username);
			localStorage.setItem("id", data.user.id);
			localStorage.setItem("isRequired", "false");
			
			toast.success(data.message || "Password changed successfully!");
			return "success";
		} catch (error) {
			console.log(error.message);
			const errorMessage = error.response?.data?.message || "Failed to change password. Please try again.";
			toast.error(errorMessage);
			return "error";
		}
	};
};
